import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Icon from "../../../components/icon/Icon";
import { useAuth } from "../../../context/authContext";
import { NavItem, NavSeparator } from "../../../components/admin/layouts/Navigation/Nav";
import User from "../../../components/admin/layouts/User/User";
import Badge from "../../../components/ui/Badge";

const UserTemplate = () => {
  const { loading: isLoading, logout, user } = useAuth();
  const navigate = useNavigate();
  const [showConfirm, setShowConfirm] = useState(false);

  const azureUserInfo = localStorage.getItem("getAzureUserData")
    ? JSON.parse(localStorage.getItem("getAzureUserData") || {})
    : null;

  const azureEmail = azureUserInfo?.identities?.find(
    (item) => item.signInType === "emailAddress"
  )?.issuerAssignedId;

  const firstName = azureUserInfo?.givenName || user?.firstName || user?.name || "";
  const lastName = azureUserInfo?.surname || user?.lastName || "";
  const email = azureEmail || user?.email || "";

  const userData = {
    id: "6",
    username: "scottnewton",
    firstName: firstName || email,
    lastName,
    email,
    password: "!123Asd",
    position: email,
    isVerified: false,
  };

  return (
    <>
      <User
        isLoading={isLoading}
        name={userData?.firstName}
        nameSuffix={userData?.isVerified && <Icon icon="HeroCheckBadge" color="blue" />}
        position={userData?.position}
        src={userData?.image?.thumb}
        suffix={<Icon icon={"HeroChevronRight"} />}
      >
        <NavSeparator />
        <NavItem text="Logout" icon="HeroArrowRightOnRectangle" onClick={() => setShowConfirm(true)} />
      </User>

      {showConfirm && (
        <div style={{ position:"fixed", inset:0, zIndex:9999, background:"rgba(0,0,0,0.5)", display:"flex", alignItems:"center", justifyContent:"center" }}>
          <div style={{ background:"#fff", borderRadius:12, padding:"28px 32px", width:320, boxShadow:"0 20px 60px rgba(0,0,0,0.3)", textAlign:"center" }}>
            <div style={{ width:48, height:48, borderRadius:"50%", background:"#fef2f2", display:"flex", alignItems:"center", justifyContent:"center", margin:"0 auto 16px" }}>
              <svg width="22" height="22" fill="none" stroke="#dc2626" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
              </svg>
            </div>
            <div style={{ fontSize:16, fontWeight:700, color:"#111827", marginBottom:8 }}>Log out?</div>
            <p style={{ fontSize:13, color:"#6b7280", marginBottom:24 }}>Are you sure you want to log out of your account?</p>
            <div style={{ display:"flex", gap:10 }}>
              <button onClick={() => setShowConfirm(false)} style={{ flex:1, padding:"10px 0", borderRadius:8, border:"1.5px solid #e5e7eb", background:"#fff", color:"#374151", fontWeight:600, fontSize:13, cursor:"pointer", fontFamily:"inherit" }}>
                Cancel
              </button>
              <button onClick={() => { setShowConfirm(false); logout(); }} style={{ flex:1, padding:"10px 0", borderRadius:8, border:"none", background:"#FEBA06", color:"#161412", fontWeight:700, fontSize:13, cursor:"pointer", fontFamily:"inherit" }}>
                Log Out
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default UserTemplate;
